import { render, staticRenderFns } from "./Cn-Select.vue?vue&type=template&id=29068ca0&"
import script from "./Cn-Select.vue?vue&type=script&lang=ts&"
export * from "./Cn-Select.vue?vue&type=script&lang=ts&"
import style0 from "./Cn-Select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
